import { CategoriesBlock } from '@components/CategoriesBlock/CategoriesBlock'
import type { CategoriesBlockProps } from '@components/CategoriesBlock/CategoriesBlock.types'
import { createAppFromCommonTemplate } from '@helpers'

export const renderCategoriesBlocksApp = (
  categoriesBlocksEl: HTMLElement | null,
  categoriesBlocksData: CategoriesBlockProps,
) => {
  createAppFromCommonTemplate(
    categoriesBlocksEl,
    <CategoriesBlock
      title={categoriesBlocksData.title}
      subtitle={categoriesBlocksData.subtitle}
      imageCards={categoriesBlocksData.imageCards}
    />,
  )
}
